
import { LOGIN_ERROR, LOGIN_FORM, LOGIN_USER_SUCCESS, LOGOUT_USER, SET_CURRENT_PROFILE, SET_IS_LOADING } from "./constants";

const initialState = {
	data: {},
	currentProfile: {},
	isAuth: false,
	token: null,
	expires: null,
	email: null,
	errorMessage: null,
	isloading: false,
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_FORM: {
			const { data } = action.payload;
			return {
				...state,
				data,
			}
		}
		case SET_CURRENT_PROFILE: {
			const currentProfile = action.payload;
			return {
				...state,
				currentProfile,
			}
		}
		case LOGIN_USER_SUCCESS: {
			const { email, token, expires } = action.payload;
			return {
				...state,
				email,
				token,
				expires,
				isAuth: true,
				errorMessage: null,
				isPending: false,
			};
		}
		case LOGOUT_USER: {
			return {
				initialState
			};
		}
		case LOGIN_ERROR: {
			const { errorMessage } = action.payload;
			return {
				...state,
				errorMessage: errorMessage
			};
		}
		case SET_IS_LOADING: {
			const { isloading } = action.payload;
			return {
				...state,
				isloading: isloading
			};
		}
		default:
			state = { ...state };
			break;
	}
	return state;
};
export default login;
